<template lang="html">

  <div class="wrapper">
    <div class="encabezado -contacto">

      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/">
            <img src="/static/img/UFV-logo.png" alt="Logo UFV">
          </router-link>
        </div>
        <h1>Contacto</h1>
      </div>

    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
        </nav>
      </div>
    </div>

    <section class="contacto container">
      <h3> ¿Tienes alguna pregunta? ¿Necesitas más información? Escríbenos, nuestro equipo se pondrá en contacto contigo para resolver tus dudas.</h3>
      <formulario></formulario>
    </section>

    
  </div>


</template>

<script lang="js">

  import formulario from '@/components/view-parts/contacto/formulario'

  export default {
    name: 'contacto',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    components: {
      formulario
    }
  }
</script>

<style scoped lang="scss">
  .contacto {}
</style>


// WEBPACK FOOTER //
// src/components/views/contacto.vue